import React, {Component, Fragment} from 'react'
import Switch from 'rc-switch'
import autobind from 'auto-bind'

export default class HubbellAikenHMI2ManualPartIncrement extends Component {
    id = 'HubbellAikenHMI2ManualPartIncrement'
    field = 'HubbellAikenHMI2ManualPartIncrement'
    constructor(props) {
        super(props)
        autobind(this)

        const initialValue =
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, 'existing') &&
            this.props.existing !== undefined
                ? this.props.existing
                : false

        this.state = {
            value: initialValue,
        }

        if (this.props && this.props.cb) {
            this.props.cb('HubbellAikenHMI2ManualPartIncrement', initialValue)
        }
    }

    handleValueChange(value) {
        this.setState({value})

        if (this.props.cb) {
            this.props.cb('HubbellAikenHMI2ManualPartIncrement', value)
        }
    }

    render() {
        return (
            <Fragment>
                <label>Manual part count entry:</label>
                <Switch
                    className="custom-switch custom-switch-primary"
                    checked={this.state.value}
                    onChange={this.handleValueChange}
                />
            </Fragment>
        )
    }
}
